import { render, staticRenderFns } from "./salespersonList.vue?vue&type=template&id=dedc04d0"
import script from "./salespersonList.vue?vue&type=script&lang=js"
export * from "./salespersonList.vue?vue&type=script&lang=js"
import style0 from "./salespersonList.vue?vue&type=style&index=0&id=dedc04d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports